import { useState, useEffect, useMemo } from "react";
import LoadingApp from "../components-library/loading/LoadingApp";
import { AnimatePresence } from "framer-motion";
import { SCREENS } from "../services/exports/Constants";
import useCompanySlug from "../hooks/global/useCompanySlug";
import ConfigManager from "../services/api/ConfigManager";
import DomainResource from "../services/resources/DomainResource";
import { ConfigInterface } from "../services/exports/Interfaces";

interface Props {
    children: JSX.Element;
}

const LoadingProvider = (props: Props): JSX.Element => {
    const { children } = props;

    const [config, setConfig] = useState<ConfigInterface | null>(null);

    const [loading, setLoading] = useState(true);

    const { slug } = useCompanySlug();

    const isHomePage = window.location.pathname === `${SCREENS.HOME_SCREEN}${slug ?? ""}`;

    async function requestConfig(): Promise<void> {
        const { response, success } = await ConfigManager.get(DomainResource.extractSubdomain());

        if (success && response?.data?.data) {
            setConfig(response.data.data);
        }
    }

    useEffect(() => {
        requestConfig();
        setTimeout(() => setLoading(false), 1000);
    }, []);

    const renderLoadingApp = useMemo(() => {
        return (
            <AnimatePresence>
                {loading && isHomePage && <LoadingApp color={config?.primary_color} logo={config?.logo_url} />}
            </AnimatePresence>
        );
    }, [loading, isHomePage, config]);

    return (
        <>
            {children}
            {renderLoadingApp}
        </>
    );
};

export default LoadingProvider;
